/** Resolves a host-relative URL (e.g. the play button's `.audio` path) against the current origin.
 *  Empty and already-absolute values are returned untouched so signed CDN URLs are never re-encoded. */
export function absoluteUrl(value) {
  if (!value || /^[a-z][a-z0-9+.-]*:/i.test(value)) return value;

  return new URL(value, window.location.origin).href;
}
